import ApiService from "@/services/api"
import { useUserStore } from "../store/user"
import { storeToRefs } from "pinia"
import { AccountingInfo, UserData } from "@/models/common"
import { setupI18n } from "@/i18n"

export const GuestChargingService = {
  basePath: "/api/v1",
  chargerLastUsageAPI: "https://ocpidev.grapetest.xyz/ocpi-cdr/api/v2", //"%GC_CHARGER_LAST_USAGE_API%",

  generateMobilitiUser: async (user: UserData, recaptchaToken?: string) => {
    return await ApiService.post(
      `${GuestChargingService.basePath}/guest-charging/generate-mobiliti-user`,
      {
        ...user,
        recaptchaToken
      }
    )
  },

  setAccountingInfo: async (accountingInfo: AccountingInfo) => {
    return await ApiService.post(
      `${GuestChargingService.basePath}/guest-charging/accounting-info`,
      accountingInfo,
      await GuestChargingService.createAuthHeader()
    )
  },

  getChargingStations: async (stationNumber: string) => {
    return await ApiService.get(
      `${GuestChargingService.basePath}/guest-charging/charging-stations/${stationNumber}`,
      {},
      await GuestChargingService.createAuthHeader()
    )
  },

  getChargingProcess: async () => {
    return await ApiService.get(
      `${GuestChargingService.basePath}/guest-charging/guest-charging-init-data`,
      {},
      await GuestChargingService.createAuthHeader()
    )
  },

  startCharging: async (evseId: string) => {
    return await ApiService.post(
      `${GuestChargingService.basePath}/guest-charging/start`,
      { evseId: evseId },
      await GuestChargingService.createAuthHeader()
    )
  },

  stopCharging: async (evseId: string) => {
    return await ApiService.post(
      `${GuestChargingService.basePath}/guest-charging/stop`,
      { evseId },
      await GuestChargingService.createAuthHeader()
    )
  },

  getChargingStatus: async () => {
    return await ApiService.get(
      `${GuestChargingService.basePath}/guest-charging/status`,
      {},
      await GuestChargingService.createAuthHeader()
    )
  },

  createAuthHeader: async (): Promise<Record<string, string>> => {
    const userStore = useUserStore()
    const { tempToken, bearerToken } = storeToRefs(userStore)
    const i18n = await setupI18n()

    const header: Record<string, string> = {}

    if (tempToken.value) {
      header.temporaryCode = tempToken.value
    }
    if (bearerToken.value) {
      header.Authorization = `Bearer ${bearerToken.value}`
    }
    if (i18n.global.locale.value) {
      header["Accept-Language"] = i18n.global.locale.value
    }
    return header
  },

  getRegistrationDocuments: async (languageCode: string) => {
    return await ApiService.get(
      `${GuestChargingService.basePath}/guest-charging/documents/registration`,
      { languageCode }
    )
  },

  getConfig: () => {
    return ApiService.get(
      `${GuestChargingService.basePath}/guest-charging/config`
    )
  }
}
